import type { FormFieldDescriptor, SensitiveFieldDescriptor } from '@finance/contracts';

export function shouldOmitFromPayload(field: FormFieldDescriptor): boolean {
  return field.sensitive?.payloadBehavior === 'omit';
}

export function shouldHashInPayload(field: FormFieldDescriptor): boolean {
  return false;
}

export function shouldMaskInDisplay(field: FormFieldDescriptor): boolean {
  return field.sensitive?.displayBehavior === 'mask';
}

export function shouldHideInDisplay(field: FormFieldDescriptor): boolean {
  return field.sensitive?.displayBehavior === 'hide';
}

export function maskValue(value: unknown): string {
  if (value === undefined || value === null || value === '') return '';
  const str = String(value);
  if (str.length <= 4) return '••••';
  return '••••' + str.slice(-4);
}

export function getDisplayValue(field: FormFieldDescriptor, value: unknown): string {
  if (shouldHideInDisplay(field)) return '';
  if (shouldMaskInDisplay(field)) return maskValue(value);
  if (value === undefined || value === null) return '';
  return String(value);
}
